import { isEmpty } from 'Util/isEmpty';

import { AvatarImage } from './AvatarImage';
import { ContactInfo } from './ContactInfo';
import { Grant } from './Grant';
import { Nullable } from './Nullable';
import { OrgRoles } from './OrgRoles';
import { EnumPresentMap, SearchableEnumPresent } from './PropertyMap';

export type OrgUser = {
    id: string
    userId: string
    org: {
        id: string
    }
    personalContactInfo: Nullable<ContactInfo>
    orgContactInfo: Nullable<ContactInfo>
    avatarImage: Nullable<AvatarImage>
    orgRoles: SearchableEnumPresent<OrgRoles.OrgRoles>
    invite: Nullable<{
        id: string
    }>
}

export function getOrgUserGrants(orgUser: OrgUser | null): EnumPresentMap<typeof Grant> {
    if (!orgUser) {
        return {}
    }
    const roles: OrgRoles.OrgRole[] = Object.keys(orgUser.orgRoles.map || {}) as OrgRoles.OrgRole[]
    return roles.reduce((acc, role) => ({ ...acc, ...OrgRoles.Flat[role]?.grants.map }), {})
}

export function orgUserIdFrom(orgId: string, appUserId: string): string {
    return `${orgId}_${appUserId}`
}

export function noOrgUserNameText(name?: Nullable<string>) {
    return isEmpty(name) ? 'Navnløst Org Bruker' : name
}
